import {useQuery} from '@tanstack/react-query';
import {fetchRest} from '../helpers/fetchRest';
import utils from '../helpers/utils';

/**
 * Fetch user scam verification cases through member-api.
 * @param {object} productFeatures - product features object from redux store.
 * @return {Object} scam verification cases data, various response status(s),
 * and customize object for handling scam verification cases and case details screen(s).
 */

export const useScamVerificationCases = (productFeatures: ProductFeatures) => {
  const isScamVerificationAvailable = utils.hasScamVerificationFeature(productFeatures);
  const url = utils.getScamVerificationCasesPath();
  const query = useQuery({
    queryKey: ['scamProtect'],
    queryFn: () =>
      fetchRest(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    enabled: isScamVerificationAvailable,
  });
  return {...query, isLoading: query.isPending};
};
